import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { DataService } from "src/app/services/Data.service";
import { DocumentsService } from "src/app/services/documents/documents.service";
import Swal from "sweetalert2";
import { DocumentsEventsService } from "../../service/documents-events.service";
import { UntypedFormControl, Validators } from "@angular/forms";

@Component({
  selector: "app-documents-add-modal",
  templateUrl: "./documents-add-modal.component.html",
  styleUrls: ["./documents-add-modal.component.css"],
})
export class DocumentsAddModalComponent implements OnInit {
  @ViewChild("closeBtn") closeBtn!: ElementRef<HTMLButtonElement>;
  @ViewChild("fileInput") fileInput!: ElementRef<HTMLInputElement>;
  userId: number;
  selectedFiles: File[] = [];
  isDragOver = false;
  overwriteWarnings: boolean[] = [];
  commentsControl = new UntypedFormControl('', [Validators.maxLength(250)]);

  constructor(
    private documentsService: DocumentsService,
    private dataService: DataService,
    private documentsEventsService: DocumentsEventsService
  ) {}

  ngOnInit(): void {
    this.dataService.currentUserIdSource.subscribe(
      (userId) => (this.userId = userId)
    );
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    this.isDragOver = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    this.isDragOver = false;
  }

  onFileSelect(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const newFiles = Array.from(input.files);
      newFiles.forEach((file) => {
        if (!this.selectedFiles.some((f) => f.name === file.name)) {
          this.selectedFiles.push(file);
          this.overwriteWarnings.push(false);
          const idx = this.selectedFiles.length - 1;
          this.checkOverwrite(file.name, idx);
        }
      });
    }
  }

  onFileDrop(event: DragEvent) {
    event.preventDefault();
    this.isDragOver = false;
    if (event.dataTransfer?.files && event.dataTransfer.files.length > 0) {
      const newFiles = Array.from(event.dataTransfer.files);
      newFiles.forEach((file) => {
        if (!this.selectedFiles.some((f) => f.name === file.name)) {
          this.selectedFiles.push(file);
          this.overwriteWarnings.push(false);
          const idx = this.selectedFiles.length - 1;
          this.checkOverwrite(file.name, idx);
        }
      });
    }
  }
  uploadDocuments() {
    if (this.selectedFiles.length === 0) return;
    const comments = this.commentsControl.value || '';
    this.documentsService
      .uploadDocuments(this.selectedFiles, this.userId, comments)
      .subscribe(
        (response) => {
          this.documentsEventsService.emitRefreshTable();
          this.success("Documents uploaded successfully!");
          this.close();
        },
        (err: Error) => {
          this.error("Error uploading documents.");
        }
      );
  }

  removeFile(index: number) {
    this.selectedFiles.splice(index, 1);
    this.overwriteWarnings.splice(index, 1);
    if (this.fileInput) {
      this.fileInput.nativeElement.value = "";
    }
  }
  close() {
    if (this.closeBtn) {
      this.closeBtn.nativeElement.click();
      this.clearFiles();
    }
  }

  clearFiles() {
    this.selectedFiles = [];
    this.overwriteWarnings = [];
    this.commentsControl.reset();
    if (this.fileInput) {
      this.fileInput.nativeElement.value = "";
    }
  }

  checkOverwrite(fileName: string, idx: number) {
    this.documentsService.checkOverwrite(fileName).subscribe((response) => {
      this.overwriteWarnings[idx] = response.data.length > 0;
    });
  }

  success(message: string) {
    Swal.fire({
      title: message,
      icon: "info",
      confirmButtonColor: "#009",
      timer: 8000,
    });
  }

  error(message: string) {
    Swal.fire({
      title: message,
      icon: "error",
      confirmButtonColor: "#009",
      cancelButtonColor: "#aaa",
    });
  }
}
